function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.75,16.6a5.23,5.23,0,0,0-4.28,2.23L10.2,15.24a5.32,5.32,0,0,0,.3-1.69,5.21,5.21,0,0,0-.3-1.68l7.27-3.59a5.24,5.24,0,1,0-1-3,5.21,5.21,0,0,0,.3,1.68l-7.27,3.6a5.25,5.25,0,1,0,0,6l7.27,3.59A5.24,5.24,0,1,0,27,21.85,5.26,5.26,0,0,0,21.75,16.6Zm0-15.1A3.75,3.75,0,1,1,18,5.25,3.75,3.75,0,0,1,21.75,1.5ZM5.25,17.3A3.75,3.75,0,1,1,9,13.55,3.75,3.75,0,0,1,5.25,17.3Zm16.5,8.3a3.75,3.75,0,1,1,3.75-3.75A3.75,3.75,0,0,1,21.75,25.6Z"
});

var SvgNetwork = function SvgNetwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27.1,
    viewBox: "0 0 27 27.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/network.c19fb1cf.svg";
export { ForwardRef as ReactComponent };